import {
  container,
  title,
  description,
  grayColor
} from "../../../material-kit-pro-react";
import { createStyles } from "@material-ui/core";

const sectionSubscribeLineStyle = createStyles({
  container,
  title,
  description,
  section: {
    padding: "1.875rem 0"
  },
  cardClasses: {
    marginTop: "30px"
  },
  icon: {
    color: grayColor[13]
  },
  formControl: {
    paddingTop: "0px !important",
    paddingBottom: "0px !important",
    margin: "0px !important"
  },
  alignItemsCenter: {
    display: "flex",
    alignItems: "center"
  }
});

export default sectionSubscribeLineStyle;
